<template>
    <main class="mt-1 mb-3">
    <div class="container">
        <div class="row mb-3">
    <div class="col text-center">
          <a href="/" class="btn btn-success mr-2 mb-2 mb-md-0"><i class="fa-solid fa-arrow-left pr-1"></i>View all properties</a>
          </div>
    </div>
<div class="row">
    <div class="col d-flex align-items-stretch pr-1 pl-0">
        <div class="card shadow property w-100">
                  <div class="card-body px-3 pt-3 pb-3 text-center">
<img :src="agent.avatar" class="agent_photo" />
<h4 class="agent m-0">{{agent.name}} {{agent.surname}}</h4>
                  </div>

        </div>
    </div>
        <div class="col d-flex align-items-stretch pl-1 pr-0">

        <div class="card shadow property w-100">
                  <div class="card-body px-3 d-flex align-items-center justify-content-center">
<div class="text-center"><img v-if="agent.company_logo" :src="agent.company_logo" class="agent_logo" :title="agent.company_name" /></div>
                  </div>
        </div>

</div>
</div>

                <!-- <div class="row my-2">
                  <div class="col-md-12">
                    <div class="row">
                    <div class="col"><button :class="'btn btn-'+sale_class+' mr-2 col'" @click="setCategory('sale')">For sale</button></div>
                    <div class="col"><button :class="'btn btn-'+rent_class+' col'" @click="setCategory('rent')">For rent</button></div>
                    </div>       
                  </div>
                </div> -->

      <!-- <div class="tab-content px-4 pt-2 pb-4">
        <search-box @filterChanged="updateFilter" ref="childRefBox"></search-box>
      </div> -->

    <search-results @filterChanged="updateFilter" @myClearFilter="clearFilter" :category="category" :filter="filter" :agent_id="agent.id" ref="childRef"></search-results>
        
</div>

  </main>
</template>

<script>

export default {
props: ['agent'],

  data() {
    return {
      category: 'rent',
      filter: {},
      sale_class: 'outline-secondary',
      rent_class: 'outline-secondary',
    };
  },

  mounted() {

    if(localStorage.getItem('propper_filter')) {
      this.filter = JSON.parse(localStorage.getItem('propper_filter'));
      this.category = this.filter.category;
    }

    if (this.category=='sale') {this.sale_class='dark'; this.rent_class='outline-secondary';}
    else {this.rent_class='dark'; this.sale_class='outline-secondary';}

  },

  created() {

    
   
  },

  methods: {

    updateFilter(val) {
        this.filter = val;
        this.filter.category = this.category;
     },

     clearFilter(type) {
      this.$refs.childRefBox.homeFilterClear(type);
     },

    setCategory(category) {
      if (category=='sale') {this.sale_class='dark'; this.rent_class='outline-secondary';}
      else {this.rent_class='dark'; this.sale_class='outline-secondary';}
      this.category = category;
      this.filter.category = this.category; 
      this.$refs.childRef.childMethod('Hi from parent');
      this.$refs.childRefBox.homeCategoryUpdate(this.category);
      },
  }

}

</script>


<style scoped>
img.agent_logo{ max-height: 80px;}
img.agent_photo{ max-width: 106px; margin-bottom: 0.5rem; border-radius:0.25rem;}
h4.agent{font-size:1.1rem; font-weight:bold; margin-bottom:0.9rem}
div.tab-pane {
  padding-top: 0.5rem;
}
.tab-content > .active {
  display: block;
  background: #1b2935;
}

div.tab-content {
  display: block;
  background: #1b2935;
  border-radius:0.3rem;
}

.btn-outline-secondary {
  color: #6c757d;
  border-color: #6c757d;
  background-color: #fff;
}

.btn-outline-secondary:hover {
  color: #6c757d;
  border-color: #53575a;
  background-color: #fff;
}
.btn-primary {
  background: #09b3e7 !important;
  color: #fff;
  border:1px solid #09b3e7 !important;
}

.btn-dark {
  color: #fff;
  background-color: #0bb2e7;
  border-color: #0bb2e7;
}
</style>